<template>
  <div>
    <b-card class="standardpage">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="pt-1">
            <i :class="log4net.icon" class="mr-1"></i>
            <span>{{ log4net.title }}</span>
          </b-col>
        </b-row>
      </b-card-header>
      <div v-if="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">
            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Date" label-size="sm">
                  <b-input-group>
                    <daterangepicker size="sm" ref="date" v-model="date" :opens="'right'" :locale-data="{
                      direction: 'ltr',
                      format: 'dd/mm/yy HH:MM',
                      applyLabel: 'Apply It',
                      cancelLabel: '< Back',
                      daysOfWeek: [
                        'Sun',
                        'Mon',
                        'Tue',
                        'Wed',
                        'Thu',
                        'Fri',
                        'Sat',
                      ],
                      monthNames: [
                        'January',
                        'February',
                        'March',
                        'April',
                        'May',
                        'June',
                        'July',
                        'August',
                        'September',
                        'October',
                        'November',
                        'December',
                      ],
                      firstDay: 1,
                    }" :ranges="locale_ranges" :showDropdowns="true" :linkedCalendars="false" :timePicker="true"
                      :timePicker24Hour="true">
                    </daterangepicker>
                    <!-- :single-date-picker="'range'" -->
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="date = {
                        startDate: null,
                        endDate: null,
                      }
                        ">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Database" label-size="sm">
                  <treeselect placeholder="Select database..." v-model="database" :multiple="false" :clearable="false"
                    :options="database_options" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Level" label-for="level" label-cols="12">
                  <treeselect instanceId="level" type="number" v-model="level" :multiple="false" :clearable="true"
                    :options="level_options"></treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Logger" label-size="sm">
                  <treeselect placeholder="Select logger..." v-model="logger" :multiple="false" :clearable="true"
                    :options="logger_options" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Message" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="message" :debounce="log4net.debounce" placeholder="Message"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" squared variant="outline-secondary" :disabled="!message"
                        @click="message = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Data" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="data" :debounce="log4net.debounce" placeholder="Message" trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" squared variant="outline-secondary" :disabled="!data" @click="data = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="log4net" :icon="log4net.icon"
            :toolbarlibrary="log4net.toolbarlibrary" :tools="log4net.tools" :badges="log4net.badges"
            :fields="log4net.fields" :items="log4net.items" :downloaded="log4net.downloaded" :limit="log4net.limit"
            :page="log4net.page" :showpages="true" :busy="log4net.busy" @load="log4net_load" @click="log4net_click"
            @select="log4net_select">
          </d-table>
          <!-- @select="log4net_select" -->
        </div>
      </div>
      <div class="px-3" v-if="log4net.selected.length == 1">
        <vue-json-pretty :deep="1" :data="log4net.selected[0].data">
        </vue-json-pretty>
        <!-- <textarea v-model="log4net.selected[0].data"  rows="10"></textarea> -->
      </div>

      <div v-if="component">
        <component :is="component" :selection="log4net.selected" :config="cconfig" @discard="log4net_click('discard')"
          @refresh="log4net_click('go')"></component>
      </div>
    </b-card>

    <!-- <Log4NetView :database="database" :selection="log4net.selected" /> -->
  </div>
</template>

<script>
import gql from "graphql-tag";
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";

import Log4NetView from "./Components/Log4NetView";

export default {
  name: "log4net",
  components: {
    Log4NetView,
    VueJsonPretty,
  },
  watch: {
    async database() {
      await this.log4net_load(0);
    },
    async date() {
      await this.log4net_load(0);
    },
    async logger() {
      await this.log4net_load(0);
    },
    async level() {
      await this.log4net_load(0);
    },
    async message() {
      await this.log4net_load(0);
    },
    async data() {
      await this.log4net_load(0);
    },
  },
  data() {
    return {
      database: "saracs_log4net",
      date: {
        startDate: this.$moment().subtract(1, "h").format("YYYY-MM-DDTHH:mm"),
        endDate: this.$moment().add(1, "h").format("YYYY-MM-DDTHH:mm"),
      },
      logger: null,
      message: null,
      data: null,
      level: null,
      level_options: [
        { id: "INFO", label: "Info" },
        { id: "ERROR", label: "Error" },
        { id: "WARNING", label: "Warning" },
      ],
      database_options: [
        { id: "saracs_log4net", label: "saracs_log4net" },
        { id: "data_log4net", label: "data_log4net" },
      ],
      logger_options: [],
      log4net: {
        title: "Log4Net Logging",
        icon: "fa fa-history text-primary pl-2",
        debounce: 500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        tools: "go,filter,download,clipboard,info,deleteconfirm",
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-right w-50px",
          },

          {
            key: "date",
            label: "Date and Time",
            sortable: true,
            class: "text-left w-120px",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .utc(false)
                  .format("DD/MM/YY HH:mm:ss.SSS");
              }
              return result;
            },
          },
          {
            key: "level",
            label: "Level",
            sortable: true,
            class: "text-center",
          },
          {
            key: "message",
            label: "Message",
            sortable: true,
            sortDirection: "desc",
            type: "text",
            class: "text-left w-700px",
            // formatter: (value, key, item) => {
            //   let result = value;
            //   if (result) {
            //     if (result.length > 160) {
            //       result = result.slice(0, 157) + "...";
            //     }
            //   }
            //   return result;
            // },
          },
          // {
          //   key: "data",
          //   label: "Data",
          //   sortable: true,
          //   sortDirection: "desc",
          //   class: "d-none d-xl-table-cell",
          //   formatter: (value, key, item) => {
          //     let result = value;
          //     if (result) {
          //       if (result.length > 100) {
          //         result = result.slice(0, 97) + "...";
          //       }
          //     }
          //     return result;
          //   },
          // },
          {
            key: "logger",
            label: "Logger",
            sortable: true,
            sortDirection: "desc",
            class: "text-center",
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [
          {
            key: "level",
            type: "badge",
            INFO: "primary",
            ERROR: "danger",
            WARNING: "warning",
          },
          {
            key: "logger",
            type: "pill",
            class: "purple",
          },
        ],
        items: [],
        selected: [],
        downloaded: [],
        denied: [],
      },
    };
  },
  async mounted() {
    await this.log4net_load(0);
  },

  methods: {
    async async_log4net_loggers() {

      const response = await this.$apollo.query({
        query: gql`
            query {
                log4net_loggers {
                  id
                  label
                }
              } 
          `,
      })
      this.logger_options = response.data.log4net_loggers;

    },
    async log4net_load(offset, limit, page) {

      let state = this.log4net;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      state.busy = true;

      let variables = {
        offset: state.offset,
        limit: state.limit,
        database: this.database,
        date: [
          this.date.startDate
            ? this.$moment(this.date.startDate).format("YYYY-MM-DD HH:mm:ss.SSS")
            : null,
          this.date.endDate
            ? this.$moment(this.date.endDate).format("YYYY-MM-DD HH:mm:ss.SSS")
            : null,
        ],
        level: this.level, // this.level.length > 0 ? this.level.join(",") : null,
        logger: this.logger,
        message: this.message,
        data: this.data,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query log4net(
              $limit: Int
              $offset: Int
              $database: String
              $date: [String]
              $level: String
              $logger: String
              $message: String
              $data: String
            ) {
              log4net(
                limit: $limit
                offset: $offset
                database: $database
                date: $date
                level: $level
                logger: $logger
                message: $message
                data: $data
              ) {
                id
                date
                level
                logger
                message
                exception
                data
                rows
              }
            }
          `,
          variables,
        });

        state.downloaded = []
        if (limit == 0) {
          state.downloaded = response.data.log4net
        } else {
          state.items = response.data.log4net;
        }


      } catch (error) {
        console.log(error);
      }
      await this.async_log4net_loggers();
      state.busy = false;
    },
    async log4net_click(a, ss) {

      let state = this.log4net;

      switch (a) {
        case "download_view":
          state.downloaded = []
          state.downloaded = this.state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.log4net_load(0, 0);
          break;


        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
        case "go":
          this.component = null;
          this.log4net_load();
          break;
        case "view":
          // this.$bvModal.show("Log4NetEvent");
          break;
        case "delete":
          this.deleteit(ss);
          break;
      }
    },

    async log4net_select(ss, tools) {

      let state = this.log4net;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "download", "clipboard"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit", "view"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async deleteit(s) {
      console.log("deleteit", s);

      let rows = [];
      s.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      console.log(variables);
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
           mutation log4net_delete($rows: [Log4net_input]) {
            log4net_delete(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.log4net_load(0);
    },
  },
};
</script>

<style></style>